// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-uKNDZ_","borderRing":"borderRing-YppSaO","glowRing":"glowRing-Syp821","badgeDisc":"badgeDisc-ntwlWN","badgeText":"badgeText-KjRXPG"};